import api from './api';

/**
 * Servicio para gestionar promociones
 */

/**
 * Obtener promoción de referido activa
 * @returns {Promise<Object>} Promoción activa o null
 */
const getPromoReferidoActiva = async () => {
  try {
    const response = await api.get('/postgres/promos/activa/referido');
    return response.data;
  } catch (error) {
    console.error('Error al obtener promoción de referido activa:', error);
    throw error;
  }
};

/**
 * Obtener todas las promociones (Admin)
 * @returns {Promise<Array>} Lista de promociones
 */
const getPromos = async () => {
  try {
    const response = await api.get('/postgres/promos');
    return response.data;
  } catch (error) {
    console.error('Error al obtener promociones:', error);
    throw error;
  }
};

/**
 * Crear nueva promoción (Admin)
 * @param {Object} promoData - Datos de la promoción
 * @returns {Promise<Object>} Promoción creada
 */
const createPromo = async (promoData) => {
  try {
    const response = await api.post('/postgres/promos', promoData);
    return response.data;
  } catch (error) {
    console.error('Error al crear promoción:', error);
    throw error;
  }
};

/**
 * Actualizar promoción (Admin)
 * @param {number} id - ID de la promoción
 * @param {Object} promoData - Datos a actualizar
 * @returns {Promise<Object>} Promoción actualizada
 */
const updatePromo = async (id, promoData) => {
  try {
    const response = await api.put(`/postgres/promos/${id}`, promoData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar promoción:', error);
    throw error;
  }
};

const promoService = {
  getPromoReferidoActiva,
  getPromos,
  createPromo,
  updatePromo
};

export default promoService;

